<template>
  <v-img :src="imgSrc(src)" :lazy-src="imgSrcLazy(src)" :srcset="imgSrcSet(src)" class="img-bg"></v-img>
</template>

<script>
import FileMixin from '@/mixins/FileMixin.js'

export default {
  name: 'HeaderImage',
  mixins: [FileMixin],
  props: {
    src: String,
    minHeight: Number,
    maxHeight: Number
  },
  data () {
    return {
      height: 0
    }
  },
  created () {
    // const breakPoints = ['xs', 'sm', 'md', 'lg', 'xl']
    // const step = Math.floor((this.maxHeight - this.minHeight) / breakPoints.length)
    // const factor = breakPoints.indexOf(this.$vuetify.breakpoint.name)
    // this.height = this.minHeight + step * factor
  }
}
</script>
